import { RcFile } from 'antd/lib/upload'

export const imageType = ['image/png', 'image/jpeg', 'image/jpg']
export const maxFileSize = 2 * 1024 * 1024 // 2MB
export const minFileSize = 1024

export const isImage = (file: RcFile) => imageType.includes(file.type)
export const isSizeMinAllowed = (file: RcFile) => minFileSize < file.size
export const isSizeMaxAllowed = (file: RcFile) => maxFileSize > file.size
